import { memo } from 'react'

import { Cell } from './Cell'
import { CellProps } from './types'

const EXCLUDED_COLUMNS: string[] = ['action', 'expander']

export const MemoizedCell = memo(
  Cell,
  <T,>(prevProps: CellProps<T>, nextProps: CellProps<T>): boolean => {
    const [
      {
        cell: {
          column: {
            columnDef: { meta: prevMeta },
          },
          getValue: prevValue,
          id: prevId,
        },
      },
      {
        cell: {
          column: {
            columnDef: { meta: nextMeta },
          },
          getValue: nextValue,
          id: nextId,
        },
      },
    ] = [prevProps, nextProps]

    const noMemo: boolean = Boolean(prevMeta?.noMemo) || Boolean(nextMeta?.noMemo)

    const containsExcludedColumns = EXCLUDED_COLUMNS.some(
      (keyword: string): boolean => prevId.includes(keyword) || nextId.includes(keyword),
    )

    if (containsExcludedColumns || noMemo) {
      return false
    }

    return prevId === nextId && prevValue() === nextValue()
  },
) as typeof Cell
